import styled, { css } from "styled-components";

export const Button = styled.button`
  ${({ theme: { colors } }) => css`
    min-width: 128px;
    height: 44px;
    width: fit-content;
    padding: 0 16px;

    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0 8px;

    &[data-color-starcheck="true"] {
      /* background: linear-gradient(180deg, #54acf2 0%, #266bf0 100%); */
      background: #266bf0;
    }

    &[data-color-log="true"] {
      /* background: linear-gradient(180deg, #83d58c 11.76%, #50d05d 100%); */
      background: #50d05d;
    }

    &[data-color-vlx="true"] {
      /* background: linear-gradient(180deg, #848484 -6.62%, #1c1c1c 100%); */
      background: #1c1c1c;
    }

    &[data-color-tokyo="true"] {
      /* background: linear-gradient(180deg, #fe4f59 0%, #e42e30 100%); */
      background: #e42e30;
    }

    &[data-variant-danger="true"] {
      border-radius: 10px;
      background: #ed0000;
      /* box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2); */
    }

    &[data-variant-text="true"] {
      width: fit-content;
      outline: none;
      background: transparent;
      box-shadow: none;
      color: rgba(32, 51, 47, 0.56);
      font-weight: 400;
    }

    &[data-variant-underline="true"] {
      width: fit-content;
      outline: none;
      background: transparent;
      box-shadow: none;
      color: rgba(32, 51, 47, 0.56);
      font-weight: 400;
      text-decoration: underline;
    }

    &[data-variant-filter="true"] {
      color: #9d9d9d;
      font-family: Mulish;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      width: fit-content;
      height: fit-content;
      padding: 5px;
      background-color: transparent;
    }

    &[data-variant-outline="true"] {
      border-radius: 10px;
      width: fit-content;
      padding: 0 20px;
      border: 1px solid #2d2d2d;
      background: transparent;
      box-shadow: none;
      color: #2d2d2d;
    }

    /* box-shadow: 0px 4px 4px 0px #00000033; */

    font-family: Mulish;
    font-size: 16px;
    font-weight: 700;
    white-space: nowrap;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: center;
    color: #fff;
    text-transform: capitalize;

    &:disabled {
      cursor: not-allowed;
      background: #b8b8b8;
    }
  `}
`;
